import styled from 'styled-components';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledErrorMessageWrapper = styled(ErrorMessageWrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
